import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
})
